<script setup>
import { ref, computed, onMounted } from 'vue';
import {
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
} from '@headlessui/vue';

import { __ } from '@/utils';
import Modal from "@components/modal.vue";
import LeadForm from "@components/leadForm/leadForm.vue";

const query = ref('');
const currentValue = ref('');
const focused = ref(false);
const mouseEnter = ref(false);
const isActive = ref(false);
const data = ref('');

const fetchCallsData = async () => {
	let jsonData = '';
    try {
		const response = await fetch(internationalCallsJson?.calls_json_url);
		jsonData = await response.json();
		data.value = jsonData;
    } catch (error) {
        console.error('Error fetching calls:', error);
    }
    return jsonData
};


const filteredList = computed(() =>
    query.value === ''
      ? data.value
      : data.value.filter((item) => {
          return item.HEB_NAME.toLowerCase().includes(query.value.toLowerCase())
        })
)

const handleFloat = (value) => parseFloat(value).toFixed(2);

onMounted(() => {
	fetchCallsData();
});

</script>

<template>
	<div class="form-pricelist__wrapper">
		<div class="form-pricelist-title">{{ __('Call rate check') }}</div>
		<form action="#" class="form-pricelist" @mouseenter="mouseEnter = true" @mouseleave="mouseEnter = false">
			<Combobox v-model="currentValue" v-slot="{ open }">
				<div class="form-pricelist__icon">
					<img :src="`${theme_path.url}/resources/images/svg/icon-pin.svg`" alt="">
				</div>
				<div class="combobox-wrapper">
					<ComboboxInput
						@change="query = $event.target.value"
						@focus="focused = true"
						:displayValue="(item) => item.HEB_NAME"
					/>
				</div>
				<ComboboxOptions class="combobox-options">
					<ComboboxOption
						class="combobox-option"
						v-for="item in filteredList"
						:key="item.HEB_NAME"
						:value="item"
					>
						{{ item.HEB_NAME }}
					</ComboboxOption>
				</ComboboxOptions>
				<div class="form-pricelist__current-selected" :class="{'is-active': focused && mouseEnter}" v-if="!open && currentValue">
					<div class="form-pricelist__inner-wrapper">
						<ul>
							<li><strong>{{ __('plan') }}</strong></li>
							<li><strong>{{ __('stationary') }}</strong></li>
							<li><strong>{{ __('mobile') }}</strong></li>
						</ul>
						<ul>
							<li>{{ __('World Package')}}</li>
							<li>{{ handleFloat(currentValue.PRICE_OLAM_NAYAH) }} ₪</li>
							<li>{{ handleFloat(currentValue.PRICE_OLAM_NAYAD) }} ₪</li>
							<li class="form-pricelist__cta">
								<button type="button" class="link-underline" @click.prevent="isActive = true">
									<span>{{ __('to join') }}</span>
								</button>
							</li>
						</ul>
						<ul>
							<li>{{ __('Xphone Cellular') }}</li>
							<li>{{ handleFloat(currentValue.PRICE_XPHONE_NAYAH) }} ₪</li>
							<li>{{ handleFloat(currentValue.PRICE_XPHONE_NAYAD) }} ₪</li>
						</ul>
						<ul>
							<li>{{ __('Casual Customers') }}</li>
							<li>{{ handleFloat(currentValue.PRICE_MEZDAMEN_NAYAH) }} ₪</li>
							<li>{{ handleFloat(currentValue.PRICE_MEZDAMEN_NAYAD) }} ₪</li>
						</ul>
					</div>
				</div>
			</Combobox>
		</form>
		<Modal class="popup--contact" :isActive="isActive" @close="isActive = false">
			<template #head>
				<div class="popup__icon">
					<img :src="`${theme_path.url}/resources/images/svg/icon-support.svg`" alt="">
				</div>
			
				<h3 class="popup__title">מעוניינים להצטרף ע"י נציג שירות?</h3>
				<h4 class="popup__subtitle">השאירו פרטים ונחזור בהקדם</h4>
			</template>
			<template #body>
				<LeadForm />
			</template>
		</Modal>
	</div>
</template>